import { usStreet } from "smartystreets-javascript-sdk";

import type { TaxAddress } from "rivals/shared/interfaces/User";

/**
 * This function only takes certain fields from smarty address suggestion, the returned fields are what matters to us
 * @param candidate address returned from smartystreets when input address is ambiguous
 * @returns object containing city, state, street1, street2 and zip fields
 */
export const extractAddressFromCandidate = (
  candidate?: usStreet.Candidate
): TaxAddress => {
  return {
    city: candidate?.components?.cityName || "",
    state: candidate?.components?.state || "",
    street1: candidate?.deliveryLine1 || "",
    street2: candidate?.deliveryLine2 || "",
    zip: candidate?.components?.zipCode || ""
  };
};

export const buildAddressLookup = (
  formAddress: TaxAddress
): usStreet.Lookup => {
  const lookup = new usStreet.Lookup();
  lookup.street = formAddress.street1 || "";
  lookup.street2 = formAddress.street2 || "";
  lookup.city = formAddress.city || "";
  lookup.state = formAddress.state || "";
  lookup.zipCode = formAddress.zip || "";
  lookup.match = "invalid";
  return lookup;
};

export const getAddressBestCandidate = (
  lookups: usStreet.Lookup[]
): usStreet.Candidate => {
  const candidates = lookups?.reduce(
    (acc: usStreet.Candidate[], lookup): usStreet.Candidate[] => {
      const lookupCandidates = lookup.result;
      return [
        ...acc,
        ...lookupCandidates.map(lookupCandidate => ({ ...lookupCandidate }))
      ];
    },
    []
  );
  return candidates[0];
};

// Address is basically valid when dpvMatchCode value is not 'N' or blank
// reference smarty documentation: https://www.smarty.com/docs/cloud/us-street-api#analysis
export const validSmartyCandidate = (
  bestCandidate?: usStreet.Candidate
): boolean => {
  if (!bestCandidate || !bestCandidate.analysis) {
    return false;
  }

  const dpvMatchCode = bestCandidate.analysis.dpvMatchCode;
  if (!dpvMatchCode || dpvMatchCode == "N") {
    return false;
  }

  return true;
};
